import { cx } from "@jugl-web/utils";
import { ButtonHTMLAttributes, ReactNode, forwardRef } from "react";

interface ChatHeaderButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  children: ReactNode;
  isActive?: boolean;
}

export const ChatHeaderButton = forwardRef<
  HTMLButtonElement,
  ChatHeaderButtonProps
>(({ children, isActive = false, className, onClick, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={cx(
        "active:bg-grey-200 flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent transition-colors",
        isActive ? "bg-grey-100" : "hover:bg-grey-100",
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
});
